import { h, render } from 'preact'
import App from './containers/App'

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const container = document.getElementById('js-shop-overview-app')

if (container) {
  let { filter, show, showless, suggested, items, adding, readmore, labelanimal, labelcategory, labelbrand, one, two, three, animal, brand, category, suggestedanimal, suggestedbrand, suggestedcategory, language, loggedin} = container.dataset;

  render(
    <App 
      filterLabel={filter} 
      showMore={show} 
      showLess={showless} 
      suggestedLabel={suggested} 
      itemsLabel={items} 
      addingLabel={adding} 
      readMoreLabel={readmore} 
      labelAnimal={labelanimal} 
      labelCategory={labelcategory} 
      labelBrand={labelbrand} 
      uspOne={one} 
      uspTwo={two} 
      uspThree={three}
      startAnimal={animal}
      startBrand={brand}
      startCategory={category}
      suggestedAnimal={suggestedanimal}
      suggestedBrand={suggestedbrand}
      suggestedCategory={suggestedcategory}
      currentLanguage={language}
      loggedIn={loggedin}
    />, container
  )
}



// WEBPACK FOOTER //
// ./src/js/shop/index.js